import gallery from "../components/gallerySplide";

gallery(4);
